module.exports = __webpack_public_path__ + "videos/mts-main-products-forms.b8893e7.webm";